import type { IconAsset } from '../Icon.types';

export const chevronLeft: IconAsset = {
  bold: {
    l: {
      code: (
        <path
          clipRule='evenodd'
          d='M6.65167 12L15.227 3.42462L17.3484 5.54594L10.8943 12L17.3484 18.454L15.227 20.5754L6.65167 12Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    m: {
      code: (
        <path
          clipRule='evenodd'
          d='M5.40903 9.99999L12.4697 2.93933L14.591 5.06065L9.65167 9.99999L14.591 14.9393L12.4697 17.0607L5.40903 9.99999Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    s: {
      code: (
        <path
          clipRule='evenodd'
          d='M4.43599 8.00002L9.32181 2.50348L11.564 4.49657L8.44985 8.00002L11.564 11.5035L9.32181 13.4966L4.43599 8.00002Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
  },
  regular: {
    l: {
      code: (
        <path
          clipRule='evenodd'
          d='M7.18199 12L15.4038 3.7782L16.818 5.19241L10.0104 12L16.818 18.8076L15.4038 20.2218L7.18199 12Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    m: {
      code: (
        <path
          clipRule='evenodd'
          d='M5.93935 10L12.6465 3.29291L14.0607 4.70712L8.76777 10L14.0607 15.2929L12.6465 16.7071L5.93935 10Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    s: {
      code: (
        <path
          clipRule='evenodd'
          d='M4.93935 8.00001L9.64645 3.29291L11.0607 4.70712L7.76777 8.00001L11.0607 11.2929L9.64645 12.7071L4.93935 8.00001Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
  },
};
